import { Card, CardContent } from "@/components/ui/card";
import { ComparisonSide } from "@/components/content/ComparisonSide";

export const ComparisonBlock = ({ comparison }) => {
  if (!comparison) return null;
  const left = comparison.left;
  const right = comparison.right;
  return (
    <section className="section-padding bg-slate-50" data-testid="comparison-block">
      <div className="container-custom max-w-5xl">
        <div className="grid md:grid-cols-2 gap-6">
          <ComparisonSide
            name={left.name}
            price={left.price}
            pros={left.pros}
            cons={left.cons}
            accent="blue"
            side="left"
          />
          <ComparisonSide
            name={right.name}
            price={right.price}
            pros={right.pros}
            cons={right.cons}
            accent="emerald"
            side="right"
          />
        </div>
        {comparison.verdict ? (
          <Card className="mt-8 border-2 border-red-200 bg-gradient-to-br from-red-50 to-white" data-testid="comparison-verdict">
            <CardContent className="p-6 comparison-verdict">
              <h3 className="text-xl font-bold text-red-700 mb-3">Verdict Mediastore Niort</h3>
              <p className="text-slate-800 leading-relaxed">{comparison.verdict}</p>
            </CardContent>
          </Card>
        ) : null}
      </div>
    </section>
  );
};
